import ComissionedPayrollList from './ComissionedPayrollList';

export default ComissionedPayrollList;